module.exports = __webpack_public_path__ + "img/b1.1f3636b0.jpg";